export function decodeText(text = '') {
  return text
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&')
    .replace(/&#34;/g, `"`)
    .replace(/&#39;/g, `'`);
}
